import { combineReducers } from "redux";
import { tracksEntriesReducer } from "modules/Tracker/services/Tracks/reducer";
import { actionsInfoReducer } from "modules/Tracker/services/Actions/reducer";

const trackerReducer = combineReducers({
    entries: tracksEntriesReducer,
    actionsInfo: actionsInfoReducer
});

export { trackerReducer };